import { TableCell } from '@mui/material';
import React, { type CSSProperties } from 'react';

import CLocalizedTextStringStatic from '../../components/CLocalizedTextStringStatic';
import { type ITableBaseCellContext } from '../../components/ITableBaseCellContext';
import { type TPandasDataFrameValue } from '../../components/TPandasDataFrameValue';
import { type TTableMutableRowContext } from '../../components/TTableMutableRowContext';

export interface CTableBaseCellConfig {
  style: (context: ITableBaseCellContext) => Omit<CSSProperties, 'width'>;
  render: (context: TTableMutableRowContext) => React.ReactNode;
  onClick: (context: ITableBaseCellContext) => void;
}

interface Props {
  rowContext: TPandasDataFrameValue[];
  cellCoordinate: [number, number];
  rowName: string;
  config: Partial<CTableBaseCellConfig> | undefined;
  colWidth: number;
  fixWidth?: boolean;
  onChange: (valueContext: Omit<ITableBaseCellContext, 'rowValues'>) => void;
  renderCoordinates?: boolean;
}

export default function CTableBaseCell(props: Props) {
  const cellValue = props.rowContext[props.cellCoordinate[0]];

  const adjustedCoordinates: [number, number] = [props.cellCoordinate[0], props.cellCoordinate[1]];

  const formattedNode = props.config?.render
    ? props.config?.render({
        value: cellValue,
        rowValues: props.rowContext,
        cellCoordinate: props.cellCoordinate,
        rowName: props.rowName,
        onChange: (value) => {
          props.onChange?.({ value, cellCoordinate: adjustedCoordinates, rowName: props.rowName });
        }
      })
    : (props.rowContext[props.cellCoordinate[0]] ?? CLocalizedTextStringStatic('global.notAvailable')).toString();
  return (
    <>
      {props.colWidth ? (
        <TableCell
          className={'relative h-[0px]'}
          style={{
            cursor: props.config?.onClick ? 'pointer' : 'auto',
            // overflow: 'hidden',
            width: props.colWidth,
            minWidth: props.fixWidth ? props.colWidth : 'initial',
            maxWidth: props.fixWidth ? props.colWidth : 'initial',
            ...props.config?.style?.({
              value: cellValue,
              rowValues: props.rowContext,
              cellCoordinate: adjustedCoordinates,
              rowName: props.rowName
            })
          }}
          onClick={() =>
            props.config?.onClick?.({
              value: cellValue,
              rowValues: props.rowContext,
              cellCoordinate: adjustedCoordinates,
              rowName: props.rowName
            })
          }
        >
          <div className={'flex flex-col !w-full !h-full justify-center items-stretch relative p-0 gap-0'}>
            {formattedNode}
          </div>
          {props.renderCoordinates && (
            <span className={'absolute top-2 left-2 bg-blue-200 text-xs'}>[{adjustedCoordinates.join(',')}]</span>
          )}
        </TableCell>
      ) : (
        <></>
      )}
    </>
  );
}
